import { ComicCondition } from './constants';
import typeHints from './typeHints';

const attributes = {

  comic_name: {
    friendly: 'Name',
    validations: {
      maxLength: 255,
    },
  },
  comic_issue_no: {
    friendly: 'Issue No',
    validations: {
      maxLength: 150,
    },
  },
  comic_series: {
    friendly: 'Series',
    validations: {
      maxLength: 150,
    },
  },
  comic_series_group: {
    friendly: 'Series Group',
    validations: {
      maxLength: 150,
    },
  },
  comic_publisher: {
    friendly: 'Publisher',
    validations: {
      maxLength: 150,
    },
  },
  comic_cover_date: {
    friendly: 'Cover Date',
    validations: {
      type: 'date',
    },
    typeHint: typeHints.Date,
  },
  comic_cover_price: {
    friendly: 'Cover Price',
    validations: {
      maxLength: 150,
    },
    typeHint: typeHints.Monetary,
  },
  comic_editor: {
    friendly: 'Editor',
    validations: {
      maxLength: 255,
    },
  },
  comic_cover_artist: {
    friendly: 'Cover Artist',
    validations: {
      maxLength: 255,
    },
  },
  comic_writer: {
    friendly: 'Writer',
    validations: {
      maxLength: 1000,
    },
  },
  comic_penciler: {
    friendly: 'Penciler',
    validations: {
      maxLength: 1000,
    },
  },
  comic_inker: {
    friendly: 'Inker',
    validations: {
      maxLength: 1000,
    },
  },
  comic_colorist: {
    friendly: 'Colorist',
    validations: {
      maxLength: 1000,
    },
  },
  comic_letterer: {
    friendly: 'Letterer',
    validations: {
      maxLength: 1000,
    },
  },
  comic_issue_ext: {
    friendly: 'Issue Ext',
    validations: {
      maxLength: 150,
    },
  },
  comic_era: {
    friendly: 'Era',
    validations: {
      maxLength: 150,
    },
  },
  comic_country_of_origin: {
    friendly: 'Country',
    validations: {
      maxLength: 150,
    },
  },
  comic_genre: {
    friendly: 'Genre',
    validations: {
      maxLength: 150,
    },
  },
  comic_format: {
    friendly: 'Format',
    validations: {
      maxLength: 150,
    },
  },
  comic_pages: {
    friendly: 'Pages',
    validations: {
      maxLength: 150,
    },
  },
  comic_language: {
    friendly: 'Language',
    validations: {
      maxLength: 150,
    },
  },
  comic_rating: {
    friendly: 'Rating',
    validations: {
      maxLength: 100,
    },
  },
  comic_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: ComicCondition,
    },
  },
  comic_grade: {
    friendly: 'Grade',
    validations: {
      maxLength: 100,
    },
  },
  comic_barcode: {
    friendly: 'Barcode',
    validations: {
      maxLength: 150,
    },
  },
  comic_defects: {
    friendly: 'Defects',
    validations: {
      maxLength: 32000,
    },
  },
  comic_read: {
    friendly: 'Read',
    validations: {
      type: 'integer',
      mustBePositive: true,
    },
  },
  comic_characters: {
    friendly: 'Characters',
    validations: {
      maxLength: 32000,
    },
  },
  comic_arcs: {
    friendly: 'Arcs',
    validations: {
      maxLength: 32000,
    },
  },
  comic_synopsis: {
    friendly: 'Synopsis',
    validations: {
      maxLength: 32000,
    },
    typeHint: typeHints.TextArea,
  },

};

export default attributes;

export const ComicRequiredAttributes = [];

export const ComicItemSearchAttributes = ['comic_publisher', 'comic_series', 'comic_issue_no'];

export const ComicDefaultSplitAttribute = 'comic_series_group';

export const ComicOverviewAttributes = [
  'title',
  'comic_series_group',
  'comic_publisher',
  'comic_era',
  'comic_country_of_origin',
  'comic_condition',
  'comic_grade',
  'rarity',
  'market_value',
  'inventory_no',
  'tags',
];

export const ComicSpecificationAttributes = [
  'comic_series',
  'comic_issue_no',
  'comic_issue_ext',
  'comic_arcs',
  'comic_cover_date',
  'comic_cover_price',
  'comic_writer',
  'comic_penciler',
  'comic_inker',
  'comic_colorist',
  'comic_letterer',
  'comic_cover_artist',
  'comic_editor',
  'comic_characters',
  'comic_synopsis',
];

export const ComicPurchaseAttributes = [
  'purchase_date',
  'purchase_price',
  'purchase_contact',
  'purchase_notes',
];

export const ComicDetailAttributes = [
  'comic_format',
  'comic_genre',
  'comic_language',
  'comic_pages',
  'comic_read',
  'comic_rating',
  'comic_barcode',
  'comic_defects',
];

export const ComicDisplayAttributes = ['comic_genre', 'comic_series', 'tags'];

export const ComicSliderGalleryAttributes = {
  titleKey: 'comic_series',
  subtitleKey: 'comic_genre',
};



// WEBPACK FOOTER //
// ./src/config/comicDataAttributes.js